module.exports = __webpack_public_path__ + "static/img-28-94e7a1f5c03b5a66ad08a65dafcd4409.jpeg";